<div class="container">
  <ng-container [ngSwitch]="route">
    <div *ngIf="isCoverpath">
      <payment-form-component
        *ngSwitchCase="'payment-form'"
        [policyType]="policyType"
        [dismiss]="dismiss"
      ></payment-form-component>
    </div>
    <div *ngIf="!isCoverpath">
      <payment-form-component *ngSwitchCase="'payment-form'" [dismiss]="dismiss"></payment-form-component>
    </div>
    <complete-component *ngSwitchCase="'complete'" [dismiss]="dismiss"></complete-component>
  </ng-container>
</div>
